jQuery(document).ready(function ($) {

    $('.js-select').select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        theme: 'pwc'
    });

    $('.js-select-form').select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        theme: 'pwc-form',
        placeholder: $(this).data('placeholder')
    }).find('option:first-child').attr('disabled', true);

    $('.woocommerce select').select2({
        width: '100%',
        theme: 'pwc-form',
        placeholder: $(this).data('placeholder')
    }).find('option:first-child').attr('disabled', true);

    $('body').on('updated_checkout', function () {
        $('.woocommerce select').select2({
            width: '100%',
            theme: 'pwc-form',
            placeholder: $(this).data('placeholder')
        }).find('option:first-child').attr('disabled', true);
    });

});
